import React, { useState } from "react";
import formatUrl from "utils/FormatUrl";
import styles from "./styles.module.css";

function index({
  t,
  lang,
  isLink,
  isPro,
  isDesk,
  canBeClosed,
}: {
  t: any;
  lang?: any;
  isLink?: boolean;
  isPro?: any;
  isDesk?: any;
  canBeClosed?: boolean;
}) {
  const [closed, setClosed] = useState(false);
  return (
    <>
      <div style={{ padding: canBeClosed ? "8px" : "0px" }}>
        <div
          className={`${styles.gangerContainer} ${
            lang === "ar" ? styles.rtl : null
          } ${isDesk ? styles.gangerContainerDesk : null}
        ${canBeClosed ? styles.canBeClosedContainer : null} ${
            closed ? styles.closedContainer : null
          }`}
        >
          {canBeClosed ? (
            <svg
              onClick={() => {
                setClosed(true);
              }}
              className={styles.closeBtn}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 18L18 6M6 6L18 18"
                stroke="#B0B5B8"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          ) : null}
          <div
            className={`${styles.textsContainer} ${
              isDesk ? styles.textsSectionDesk : null
            }`}
          >
            <div
              className={`${
                isPro ? styles.labelAnnonceVerified : styles.blueExclu
              } ${lang === "ar" ? styles.rtl : null}`}
            >
              {isPro ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 26 26"
                  fill="none"
                >
                  <path
                    d="M9.74838 12.9994L11.915 15.166L16.2484 10.8327M8.48602 5.08783C9.26334 5.0258 10.0013 4.72013 10.5948 4.21434C11.9798 3.03402 14.0169 3.03402 15.402 4.21434C15.9955 4.72013 16.7334 5.0258 17.5107 5.08783C19.3247 5.23258 20.7652 6.67302 20.9099 8.48699C20.9719 9.26432 21.2776 10.0023 21.7834 10.5958C22.9637 11.9808 22.9637 14.0179 21.7834 15.4029C21.2776 15.9964 20.9719 16.7344 20.9099 17.5117C20.7652 19.3257 19.3247 20.7661 17.5107 20.9109C16.7334 20.9729 15.9955 21.2786 15.402 21.7844C14.0169 22.9647 11.9798 22.9647 10.5948 21.7844C10.0013 21.2786 9.26334 20.9729 8.48602 20.9109C6.67205 20.7661 5.23161 19.3257 5.08685 17.5117C5.02482 16.7344 4.71915 15.9964 4.21336 15.4029C3.03305 14.0179 3.03305 11.9808 4.21336 10.5958C4.71915 10.0023 5.02482 9.26432 5.08685 8.48699C5.23161 6.67302 6.67205 5.23258 8.48602 5.08783Z"
                    stroke="#00B4FF"
                    stroke-width="2.3875"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.24991 10.9999L10.0832 12.8332L13.7499 9.16658M7.18175 4.30553C7.83949 4.25305 8.46391 3.9944 8.96612 3.56643C10.1381 2.5677 11.8618 2.5677 13.0337 3.56643C13.5359 3.9944 14.1603 4.25305 14.8181 4.30554C16.353 4.42802 17.5718 5.64686 17.6943 7.18175C17.7468 7.83949 18.0054 8.46391 18.4334 8.96612C19.4321 10.1381 19.4321 11.8618 18.4334 13.0337C18.0054 13.5359 17.7468 14.1603 17.6943 14.8181C17.5718 16.353 16.353 17.5718 14.8181 17.6943C14.1603 17.7468 13.5359 18.0054 13.0337 18.4334C11.8618 19.4321 10.1381 19.4321 8.96612 18.4334C8.46391 18.0054 7.83949 17.7468 7.18175 17.6943C5.64686 17.5718 4.42802 16.353 4.30553 14.8181C4.25305 14.1603 3.9944 13.5359 3.56643 13.0337C2.5677 11.8618 2.5677 10.1381 3.56643 8.96612C3.9944 8.46391 4.25305 7.83949 4.30554 7.18175C4.42802 5.64686 5.64686 4.42802 7.18175 4.30553Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              )}
              <span>{t("Exclu Agenz")}</span>
            </div>
            <div className={`${lang === "ar" ? styles.rtl : null} `}>
              {isPro ? (
                <h1 className={styles.gangerText}>
                  {t("Vendez ces biens")} :{" "}
                  <span style={{ color: isPro ? "#2cd189" : "#00b4ff " }}>
                    {t("1 % HT")}
                  </span>{" "}
                  {t("vendeur garantie")}
                </h1>
              ) : (
                <h1 className={styles.gangerTextNotPro}>
                  {t("Vendez ces biens")} : {t("gagnez 1 % HT de comission")}
                </h1>
              )}
              <p className={styles.gangerSubText}>
                {t("Gardez 100 % de la commission acheteur")}
              </p>
            </div>
          </div>
          {isLink ? (
            <a
              className={`${styles.linkToBiens} ${
                isDesk ? styles.linkToBiensDesk : null
              } ${lang === "ar" ? styles.rtlAnchor : null}`}
              href={formatUrl(
                "/list.htm?transaction_type=vente&exclusivite=true",
                lang
              )}
              rel={"noindex, nofollow"}
            >
              {t("Voir les biens")}
              {isDesk ? (
                <svg
                  width="13"
                  height="14"
                  viewBox="0 0 13 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.875 3.20866L8.66667 7.00032L4.875 10.792"
                    stroke="#00B4FF"
                    stroke-width="1.08333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M5.375 3.20866L9.16667 7.00032L5.375 10.792"
                    stroke="white"
                    stroke-width="1.08333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              )}
            </a>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default index;
